import { SearchResultsEffects } from './search-results.effect';

export const effects = [SearchResultsEffects];
export * from './search-results.effect';
